import React from 'react'
import styled from "styled-components";
import NopermissionImg from "@/img/no-permission.png";
import { Button } from "antd";
import { hrefChangeUrl } from "@/utils/utils";

const ContentDiv = styled.div`
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 160px 0;

  .img-div{
    width: 200px;
    height: 214px;

    img{
      width: 100%;
      height: 100%;
    }
  }

  .text-div{
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    margin: 40px 0 32px;
    text-align: center;
  }
`

const NoPermission = () => {
  return (
    <ContentDiv>
      <div className="img-div">
        <img src={NopermissionImg} alt="" />
      </div>
      <div className="text-div">
        <div>您的账号未进行企微账号绑定</div>
        <div>请到部门与用户设置页面完成<span style={{color:"#FC8352"}}>绑定</span>后才能使用</div>
      </div>
      <Button type="primary" onClick={()=>{
        // window.location.href = `${window.location.origin}/usercenter?apptoken=${SERVER.wxAppToken}#/department-lx`
        hrefChangeUrl(`${window.location.origin}/usercenter?apptoken=${SERVER.wxAppToken}#/department-lx`)
      }}>去绑定</Button>
    </ContentDiv>
  )
}

export default NoPermission;
